import { render, staticRenderFns } from "./OrderNewFormTab.vue?vue&type=template&id=a75c3f9c"
import script from "./OrderNewFormTab.vue?vue&type=script&lang=js"
export * from "./OrderNewFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports